import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import DropdownSelect from '../DropdownSelect'

export const UserSelectionInput = ({onSelectAzubi, selectedAzubiId, isDisabled, azubis}) => {
  const [options, setOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState()

  useEffect(() => {
    setOptions(azubis.map(user => ({value: user.id, label: `${user.lastname}, ${user.firstname}`})))
  }, [azubis])

  useEffect(() => {
    setSelectedOption(options.find(o => o.value === selectedAzubiId))
  }, [options, selectedAzubiId])

  return (
    <div className="azubiSelect">
      {!isDisabled && (
        <DropdownSelect
          options={options}
          selectedOption={selectedOption}
          handleSelect={evt => onSelectAzubi(evt.value)}
          isDisabled={isDisabled}
        />
      )}
    </div>
  )
}

UserSelectionInput.propTypes = {
  azubis: PropTypes.array,
  selectedAzubiId: PropTypes.number,
  onSelectAzubi: PropTypes.func,
  isDisabled: PropTypes.bool,
}

export default UserSelectionInput
